import { useState, useEffect } from 'react';
import { useFetchOrganizationConfigQuery, useUpdateOrganizationConfigMutation, useCreateOrganizationConfigMutation } from '../../../../common/api/lmsApi';
import md5 from 'md5'


export const useThinkificConfig = (organizationId: string) => {
  const [isUpdate, setIsUpdate] = useState(false);
  const [config, setConfig] = useState({
    lmsUrl: '',
    proviewAdminUsername: '',
    proviewAdminPassword: '',
    proviewName:'',
    isAutoSyncEnabled: false,
  });
  const { data, error, isLoading } = useFetchOrganizationConfigQuery(organizationId);
  const [updateOrganizationConfig] = useUpdateOrganizationConfigMutation();
  const [createOrganizationConfig] = useCreateOrganizationConfigMutation();

  useEffect(() => {
    if (data) {
      setIsUpdate(true);
      setConfig({
        lmsUrl: data?.lms_config?.thinkific.url || '',
        proviewName:data?.name || '',
        proviewAdminUsername: data?.lms_config?.thinkific.secrets.proview_admin_username || '',
        proviewAdminPassword: data?.lms_config?.thinkific.secrets.proview_admin_password || '',
        isAutoSyncEnabled: data?.is_auto_sync || false,
      });
    }
  }, [data]);


  const handleUpdateConfiguration = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const appId = md5(config.lmsUrl).toString();
    const data = {
      lms_config: {
        type: 'THINKIFIC',
        thinkific: {
          secrets: {
            proview_admin_username: config.proviewAdminUsername,
            proview_admin_password: config.proviewAdminPassword,
          },
          url: config.lmsUrl,
        },
      },
      app_id: appId,
      is_auto_sync: config.isAutoSyncEnabled,
      proview_organization_id: organizationId,
      name: config.proviewName,
    };
    if (isUpdate) {
      updateOrganizationConfig({ organizationId, data })
        .then(() => alert('Configuration updated successfully.'))
        .catch((error) => console.error('Error updating configuration:', error));
    } else {
      createOrganizationConfig(data)
        .then(() => alert('Configuration created successfully.'))
        .catch((error) => console.error('Error creating configuration:', error));
    }
  };

  return {
    config,
    setConfig,
    isUpdate,
    isLoading,
    handleUpdateConfiguration,
  };
};
